// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-22-2024
// ***********************************************************************
// <copyright file="_tooltip.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for initializing and managing Bootstrap tooltips 
//     in a Blazor application, enabling rich user interactions with tooltip components.
// </summary>
// ***********************************************************************

window.tooltip = window.tooltip || {};

/**
 * Initializes Bootstrap tooltips for all elements that have a `title` attribute.
 * This function scans the DOM for elements with a `title` attribute, automatically
 * setting up Bootstrap tooltips for these elements to enhance user interaction.
 * 
 * @function initialize
 * @memberof window.tooltip
 */
window.tooltip.initialize = function () {
    const elements = document.querySelectorAll('[title]');
    elements.forEach(element => {
        console.log(element);
        element.setAttribute('data-bs-toggle', 'tooltip');
    });

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
};

/**
 * Hides all currently visible Bootstrap tooltips.
 * This function searches the DOM for visible tooltips and hides them,
 * ensuring that any active tooltips are properly dismissed.
 * 
 * @function hide
 * @memberof window.tooltip
 */
window.tooltip.hide = function () {
    const tooltips = document.querySelectorAll('.tooltip.bs-tooltip-auto.fade.show');
    tooltips.forEach(tooltipEl => {
        const tooltip = bootstrap.Tooltip.getInstance(tooltipEl);
        if (tooltip) {
            tooltip.hide();
        } else {
            tooltipEl.classList.remove('show');
        }
    });
};
